module.exports = __webpack_public_path__ + "images/category_lp/art_work/new/assessment_achievements/2_45cf33e2dcb5999f2b8f76f02c01400b.png";